import React from "react";
import PropTypes from "prop-types";

const References = ({ element }) => {
  if (!element) {
    return null;
  }
  return (
    <div>
      {element["story-elements"].map(element => {
        let { description, name, url } = element.metadata;
        return (
          <div key={element.id} className="story-element-reference">
            {name && url && <h5 className="story-element-reference-title">{name}</h5>}
            {description &&
              url && (
                <a target="_blank" rel="noopener noreferrer" className="story-element-reference-link" href={url}>
                  {description}
                </a>
              )}
          </div>
        );
      })}
    </div>
  );
};

References.propTypes = {
  element: PropTypes.shape({
    "story-elements": PropTypes.arrayOf({
      metadata: PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        description: PropTypes.string
      }),
      id: PropTypes.string
    })
  })
};

export { References };
